function formatForRechartsMultiseries(results) {
  /*** before...results looks like: ***/
  /*** [ {choice, amount}, {choice, amount}, {choice, amount} ] ***/
  let reformatted = {};
  for (let segment of results) {
    const newKey = segment.choice;
    /* I know that it is not safe to have a wild string as a key... fix that. Learn more about recharts... */
    reformatted[newKey] = segment.amount;
  }
  return reformatted;
}

export function formatForTimelineSingleChoice(results) {
  /*
    Input looks like:
      [ {year, results}, {year, results}, {year, results} ]

    and inside this, results looks like (just like in the case single-choice)
      [ {choice, amount}, {choice, amount}, {choice, amount} ]
  */

  /*
    Output needs to look like:
    [
      { year: 2015, amountYes: 60, amountNo: 50, amountNA: 82 },
      { year: 2016, amountYes: 90, amountNo: 20, amountNA: 82 }
    ];
  */

  let reformatted = [];
  for (let yearData of results) {
    let newYearData = formatForRechartsMultiseries(yearData.results);
    newYearData.year = yearData.year;
    reformatted.push(newYearData);
  }
  return reformatted;
}

export function removeYearFromArray(array) {
  let allKeys = array;
  const index = allKeys.indexOf('year');
  if (index !== -1) {
    allKeys.splice(index, 1);
  }
  return allKeys;
}



// WEBPACK FOOTER //
// ./src/components/Statistics/Views/utils.js